var _desc, _rect, _circle, _circle2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _circle3, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogNetsuiteCustomization(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 700",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "NetSuite customization dashboard illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A cloud ERP dashboard with connected workflow cards.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    fill: "#07111f"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 140,
    r: 150,
    fill: "#0e7490",
    opacity: 0.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1030,
    cy: 560,
    r: 210,
    fill: "#14b8a6",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 105,
    width: 960,
    height: 490,
    rx: 34,
    fill: "#0f172a",
    stroke: "#1e3a4a",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 160,
    width: 295,
    height: 160,
    rx: 22,
    fill: "#123241"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 505,
    y: 160,
    width: 245,
    height: 160,
    rx: 22,
    fill: "#102a3a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 160,
    width: 240,
    height: 160,
    rx: 22,
    fill: "#123241"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 365,
    width: 385,
    height: 150,
    rx: 22,
    fill: "#0d2636"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 595,
    y: 365,
    width: 435,
    height: 150,
    rx: 22,
    fill: "#0d2636"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316 320v45m334-45v45m260-45v45M555 440h40",
    stroke: "#22d3ee",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 240,
    r: 54,
    fill: "#14b8a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286 242h64M318 210v64",
    stroke: "#ecfeff",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M548 235h158M548 270h118M832 230h154M832 270h92M215 425h270M215 465h190M650 425h310M650 465h230",
    stroke: "#cbd5e1",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M832 510c42-92 112-94 154-12",
    fill: "none",
    stroke: "#14b8a6",
    strokeWidth: 14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogNetsuiteCustomization);
export default __webpack_public_path__ + "static/media/blog-netsuite-customization.cc3ac4fe81453572de6a9b6739c6c26c.svg";
export { ForwardRef as ReactComponent };